import { bl_wf_md_action_type_RowClass, bl_wf_md_action_type_RowInterface } from "../../../dbschema";
import {BaseContainerModel} from "../../base-container.model";

export class WfMdActionTypeContainerModel extends BaseContainerModel{
  bl_wf_md_action_type: bl_wf_md_action_type_RowInterface = new bl_wf_md_action_type_RowClass();
}
